import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isPathDisabled, getDefaultEnabledRoute } from '../../utils/routeRedirectUtils';
import { showToast } from '../../utils/toastNotification';
import ROUTE_PATH from '../../constants/routes';

const ProtectedRoute = ({ children, modulePrefix, permission }) => {
    const { auth, isLoading, checkRouteAccess, checkModuleAccess, checkPermission } = useAuth();
    const location = useLocation();

    let hasAccess = true;
    if (!isLoading && auth.isAuthenticated) {
        if (modulePrefix && checkModuleAccess) {
            hasAccess = checkModuleAccess(modulePrefix);
        } else if (permission && checkPermission) {
            hasAccess = checkPermission(permission);
        } else if (checkRouteAccess) {
            hasAccess = checkRouteAccess(location.pathname);
        }
    }

    useEffect(() => {
        if (!isLoading && auth.isAuthenticated && !hasAccess) {
            showToast.error('Bạn không có quyền truy cập vào chức năng này!');
        }
    }, [auth.isAuthenticated, isLoading, hasAccess, location.pathname]);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!auth.isAuthenticated) {
        return <Navigate to={ROUTE_PATH.LOGIN} state={{ from: location }} replace />;
    }

    if (isPathDisabled(location.pathname)) {
        const defaultRoute = getDefaultEnabledRoute();
        return <Navigate to={defaultRoute} replace />;
    }

    if (!hasAccess) {
        return <Navigate to={ROUTE_PATH.DASHBOARD} replace />;
    }

    return children;
};

export default ProtectedRoute;